const AUTOMATIC_PAYMENT_METHODS = new Set(["qris", "transfer"]);

export const isAutomaticPaymentMethod = (paymentMethod) => AUTOMATIC_PAYMENT_METHODS.has(paymentMethod);

export const normalizeCurrencyInput = (value) => {
  if (value === "") {
    return "";
  }

  const amount = Number(value);
  return Number.isFinite(amount) ? Math.max(0, amount) : "";
};

export const getRecordedSalePayment = (sale) =>
  Math.min(Math.max(0, Number(sale?.pay) || 0), Math.max(0, Number(sale?.total) || 0));

// pay is the amount tendered now, never the previous payment on an edited sale.
export const getPosPaymentPreviewAmount = (state = {}) => Math.max(0, Number(state.pay) || 0);

export const calculatePosPayment = (state = {}, isDiscountEnabled = false, options = {}) => {
  const subtotal = (state.details || []).reduce((sum, item) => sum + Number(item?.subtotal || 0), 0);
  const discount = isDiscountEnabled ? Math.max(0, Number(state.discount || 0)) : 0;
  const tax = Math.max(0, Number(state.tax || 0));
  const total = Math.max(0, subtotal - discount + tax);
  const remaining = Math.max(0, total - Math.max(0, Number(options.paidAmount) || 0));
  const autoFillPayment = Boolean(options.autoFillPayment) && isAutomaticPaymentMethod(state.payment_method);
  const numericPay = autoFillPayment ? remaining : Math.max(0, Number(state.pay || 0));

  return {
    subtotal,
    total,
    pay: autoFillPayment ? remaining : (state.pay ?? 0),
    due: Math.max(0, remaining - numericPay),
    change: Math.max(0, numericPay - remaining),
  };
};
